import { render, staticRenderFns } from "./FormulariosFiltros.vue?vue&type=template&id=54aff9a8"
import script from "./FormulariosFiltros.vue?vue&type=script&lang=js"
export * from "./FormulariosFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports